import Vue from "vue";
import moment from "moment";
import { isNumeral } from "numeral";

Vue.filter("formatDateTime", function (value) {
    let fmt = "DD/MM/YYYY HH:mm:ss";
    if (value) {
        value = value.includes("Z") ? new Date(value) : new Date(value + "Z");
        return moment
            .utc(value, fmt)
            .local()
            .format(fmt);
    }
});

Vue.filter("formatTime", function (value) {
    let fmt = "HH:mm:ss";
    if (value) {
        value = value.includes("Z") ? new Date(value) : new Date(value + "Z");
        return moment
            .utc(value, fmt)
            .local()
            .format(fmt);
    }
});

Vue.filter("formatDateTimeUTC", function (value) {
    let fmt = "DD/MM/YYYY HH:mm:ss";
    if (value) {
        value = value.includes("Z") ? new Date(value) : new Date(value + "Z");
        return moment.utc(value, fmt).format(fmt);
    }
});

Vue.filter("formatDate", function (value) {
    let fmt = "DD/MM/YYYY";
    if (value) {
        value = value.includes("Z") ? new Date(value) : new Date(value + "Z");
        return moment
            .utc(value, fmt)
            .local()
            .format(fmt);
    }
});

Vue.filter("formatDateComplete", function (value) {
    let fmt = "llll";
    if (value) {
        value = value.includes("Z") ? new Date(value) : new Date(value + "Z");
        return moment
            .utc(value, fmt)
            .local()
            .format(fmt);
    }
});


Vue.filter("formatDateShort", function (value) {
    let fmt = "DD/MM";
    if (value) {
        value = value.includes("Z") ? new Date(value) : new Date(value + "Z");
        return moment
            .utc(value, fmt)
            .local()
            .format(fmt);
    }
});

Vue.filter("formatDateUTC", function (value) {
    let fmt = "DD/MM/YYYY";
    if (value) {
        value = value.includes("Z") ? new Date(value) : new Date(value + "Z");
        return moment.utc(value, fmt).format(fmt);
    }
});

Vue.filter("formatDateAgo", function (value) {
    if (value) {
        value = value.includes("Z") ? new Date(value) : new Date(value + "Z");
        return moment(value).fromNow();
    }
});

Vue.filter("formatSizeFile", size => {
    size = parseInt(size);
    if (Number.isInteger(size)) {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (size == 0) return '0 Byte';
        var i = parseInt(Math.floor(Math.log(size) / Math.log(1024)));
        return Math.round(size / Math.pow(1024, i), 2) + ' ' + sizes[i];
    }
});

Vue.filter("formatBigNumber", number => {
    if (typeof number !== "number" && typeof number !== "string") {
        return "";
    }

    number = parseFloat(number);

    if (isNaN(number)) {
        return "";
    }

    const formatter = new Intl.NumberFormat("pt-BR", {
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

    return formatter.format(number);
});

Vue.filter("forecastType", type => {
    switch (type) {
        case "LEMMIT_TREATMENT":
            return "Tratamento"
        default:
            return "Notificação"
    }
});

Vue.filter('phoneNumber', function (value) {
    if (!value) {
        return '';
    }

    let phone = value.replace(/\D/g, '');

    if (phone.length > 11) {
        phone = phone.slice(2); // Remove o código do país
    }

    if (phone.length > 10) {
        return phone.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3'); // (99) 99999-9999
    } else if (phone.length == 10) {
        return phone.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3'); // (99) 9999-9999
    }

    return phone;
});

Vue.filter('whatsappSenderQuality', function (value) {
    return {
        'HIGH': 'Alta',
        'LOW': 'Baixa',
        'MEDIUM': 'Média',
        'UNKNOWN': 'Pendente',
        'GREEN': 'Alta',
        'RED': 'Baixa',
        'YELLOW': 'Média',
        'UNKNOWN': 'Pendente'
    }[value] || value;
});



// https://developers.facebook.com/docs/whatsapp/business-management-api/message-templates#template-categories
// https://www.infobip.com/docs/api/channels/whatsapp/whatsapp-service-management/get-whatsapp-templates
Vue.filter('whatsappTemplateCategory', function (value) {
    return {
        'AUTHENTICATION': 'Autenticação',
        'MARKETING': 'Marketing',
        'UTILITY': 'Utilidade',
    }[value] || value;
});

// https://developers.facebook.com/docs/whatsapp/business-management-api/message-templates#template-status
// https://www.infobip.com/docs/api/channels/whatsapp/whatsapp-service-management/get-whatsapp-templates
Vue.filter('whatsappTemplateStatus', function (value) {
    return {
        'APPROVED': 'Ativo',
        'PAUSED': 'Pausado',
        'FIRST_PAUSED': 'Primeira pausa',
        'SECOND_PAUSED': 'Segunda pausa',
        'PENDING': 'Pendente',
        'REJECTED': 'Recusado',
        'DISABLED': 'Desativado',
        'PENDING_DELETION': 'Pendente de exclusão',
        'DELETED': 'Excluído',
        'FLAGGED': 'Sinalizado',
        'IN_APPEAL': 'Em recurso',
        'REINSTATED': 'Reativado',
    }[value] || value;
});

// https://www.infobip.com/docs/api/channels/whatsapp/whatsapp-service-management/get-whatsapp-templates
Vue.filter('whatsappTemplateQuality', function (value) {
    return {
        'HIGH': 'Alta',
        'MEDIUM': 'Média',
        'LOW': 'Baixa',
        'GREEN': 'Alta',
        'YELLOW': 'Média',
        'RED': 'Baixa',
        'UNKNOWN': 'Pendente',
    }[value] || value;
});

Vue.filter('strategyPublic', function (value) {
    return {
        'IMPORTED': 'Importados',
        'UNCHECKED': 'Não Verificados',
        'CHECKED': 'Verificados',
        'LOCATED': 'Localizados',
    }[value] || value;
});
Vue.filter('firingType', function (value) {
    return {
        'AUTO': 'Automático',
        'MANUAL': 'Manual',
        'INCENTIVE': 'Incentivo',
        'ORGANIC': 'Orgânico'
    }[value] || value;
});
